/**
 * EL CABLE SE COTIZA EN METROS.
 *
 * Johan: «siguen saliendo Und.». En World Office 2.731 productos dicen «Und.»
 * y solo 7 dicen «m»: el maestro casi nunca trae la unidad buena, y el
 * técnico tenía que cambiarla a mano renglón por renglón —en la OS-2026-0100
 * Daniel la cambió en el cable amarillo y no en el blanco ni en el verde—.
 *
 * Solo cable y alambre. Tubo, canaleta y similares NO: el historial dice que
 * se venden por pieza («TUBO CONDUIT PVC 1/2» a 3.361 cada uno, que es el
 * precio del tubo y no del metro). Y solo cuando la unidad está vacía o en
 * «Und.»: si alguien escribió otra cosa a propósito, se respeta.
 */
const SE_VENDE_POR_METRO = /^\s*(?:[A-Za-z0-9]+\s+-\s+)?(cable|alambre|cord[oó]n)\b/i

export function unidadDeEntrada(descripcion: string, unidad: string | null): string | null {
  const generica = !unidad || /^\s*und\.?\s*$/i.test(unidad)
  if (generica && SE_VENDE_POR_METRO.test(descripcion)) return 'm'
  return unidad
}
